import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../app-kit/components/DialogModal/DialogModal';

interface DemographicsDataDisclaimerModalProps {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const DemographicsDataDisclaimerModal: FunctionComponent<
  DemographicsDataDisclaimerModalProps
> = ({ opened, onClose }) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="Demographic data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
    >
      <BodyText>
        All demographics data is provided by the Australian Bureau of Statistics (ABS). The data is
        provided at a point-in-time, using the latest available Census results from 2021.
      </BodyText>
      <BodyText>
        Households — Australian Bureau of Statistics (2021) &apos;Household composition (HHCD)&apos;
        Data, accessed 01 December 2023. Population - Australian Bureau of Statistics (2021)
        &apos;Sex (SEXP)&apos; Data, accessed 01 December 2023. Property Ownership — Australian
        Bureau of Statistics (2021) &apos;Tenure type (TEND), Census of Population and Housing&apos;
        Data, accessed 01 December 2023.
      </BodyText>
      <BodyText>
        Household Income - Australian Bureau of Statistics (2021) &apos;Total household income
        (weekly) (HIND), Census of Population and Housing&apos; Data, accessed 01 December 2023.
        Other includes all data that is categorised as &apos;other&apos; or &apos;not stated&apos;.
      </BodyText>
      <BodyText>
        Age Groups — Australian Bureau of Statistics (2021) &apos;Age (AGEP), Census of Population
        and Housing&apos; Data, accessed 01 December 2023.
      </BodyText>
    </DialogModal>
  );
};
